import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let HrGeneralizationsAlertsUrl = CONFIG.baseUrls.HrGeneralizationsAlertsSetup;
export interface HrGeneralizationsAlerts {
    serial?: number;
    circularHeader?: string;
    CircularBody?: string;
    allGroups?: number;
    groupCode?: number;
    specificGroups?: number;
    selectedGroupsStr?: string
    groupsList?: string;
    mode?: number;
    userId?: number;
    isRead?: number;
    downloadFileName?: string;
}
@Injectable()
export class HrGeneralizationsAlertsService {
    constructor(private httpGeneralService: HttpGeneralService) { }
    getHrGeneralizationsAlerts(_HrGeneralizationsAlerts: HrGeneralizationsAlerts) {
        return this.httpGeneralService.add<HrGeneralizationsAlerts>(_HrGeneralizationsAlerts, HrGeneralizationsAlertsUrl + "/HrGeneralizationsAlertsSetupLoad");
    }
    addHrGeneralizationsAlerts(_HrGeneralizationsAlerts: HrGeneralizationsAlerts) {
        return this.httpGeneralService.add<HrGeneralizationsAlerts>(_HrGeneralizationsAlerts, HrGeneralizationsAlertsUrl);
    }
    updateHrGeneralizationsAlerts(_HrGeneralizationsAlerts: HrGeneralizationsAlerts) {
        return this.httpGeneralService.update<HrGeneralizationsAlerts>(_HrGeneralizationsAlerts.serial, _HrGeneralizationsAlerts, HrGeneralizationsAlertsUrl);
    }
    deleteHrGeneralizationsAlerts(_HrGeneralizationsAlerts: HrGeneralizationsAlerts) {
        return this.httpGeneralService.delete<number>(_HrGeneralizationsAlerts.serial, HrGeneralizationsAlertsUrl);
    }
}
